import React, { memo } from 'react';
export function Footer() {
  return <footer className="bg-black text-white py-16 px-4 md:px-8" data-id="element-53">
      <div className="container mx-auto" data-id="element-54">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-55">
          <div data-id="element-56">
            <h3 className="text-3xl font-['Caveat'] mb-6 text-[#FFB5C5]" data-id="element-57">
              Beep Books
            </h3>
            <p className="text-gray-400 mb-6 max-w-xs" data-id="element-58">
              Capturing memories, one voicemail at a time. The modern way to
              remember your vintage wedding.
            </p>
          </div>

          <div data-id="element-59">
            <h4 className="font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-60">
              Information
            </h4>
            <ul className="space-y-3 text-gray-400" data-id="element-61">
              <li data-id="element-62">
                <a href="#how-it-works" className="hover:text-white transition-colors" onClick={e => {
                e.preventDefault();
                document.getElementById('how-it-works')?.scrollIntoView({
                  behavior: 'smooth'
                });
              }} data-id="element-63">
                  How it Works
                </a>
              </li>
              <li data-id="element-64">
                <a href="#pricing" className="hover:text-white transition-colors" onClick={e => {
                e.preventDefault();
                document.getElementById('pricing')?.scrollIntoView({
                  behavior: 'smooth'
                });
              }} data-id="element-65">
                  Pricing & Packages
                </a>
              </li>
              <li data-id="element-66">
                <a href="mailto:mybeepbook@gmail.com" className="hover:text-white transition-colors" data-id="element-67">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-68">
            <h4 className="font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-69">
              Newsletter
            </h4>
            <div className="flex border-b border-gray-700 pb-2" data-id="element-70">
              <input type="email" placeholder="Enter your email" className="bg-transparent border-none focus:ring-0 text-white w-full placeholder-gray-600" data-id="element-71" />
              <button className="text-[#FFB5C5] font-bold uppercase text-xs hover:text-white transition-colors" data-id="element-72">
                Subscribe
              </button>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-16 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-600" data-id="element-73">
          <p data-id="element-74">&copy; 2024 Beep Books Audio Guest Books. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-75">
            <a href="#" className="hover:text-gray-400" data-id="element-76">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-gray-400" data-id="element-77">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}